import { render, staticRenderFns } from "./WeCallYouDetails.vue?vue&type=template&id=13cfd795&"
import script from "./WeCallYouDetails.vue?vue&type=script&lang=js&"
export * from "./WeCallYouDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports